import React, { FC } from 'react'

import { classNames } from '../../utils/Helpers'

interface toogleProps {
    name: any,
    label: any,
    checked: boolean,
    disabled?: boolean,
    description?: any,
    changeHandler: any,
}

export const ToggleSwitch: FC<toogleProps> = ({ label, name, description, disabled = false, changeHandler, checked }) => {
    return (
        <>
            <label htmlFor={name} className='relative flex select-none gap-x-2 w-full'>
                <div className="flex-grow">
                    <span aria-disabled={disabled} className='label flex items-center text-slate-600 font-medium dark:text-slate-300 disabled:text-slate-500 text-sm'>
                        {label}
                    </span>
                </div>

                <input id={name} disabled={disabled} type="checkbox" name={name} className="sr-only" checked={checked} onChange={changeHandler} />
                <span aria-disabled={disabled} className={classNames(
                    checked ? 'bg-orange-500' : 'bg-[#CCCCCE] dark:bg-slate-500',
                    "slider flex h-[24px] w-[44px] items-center rounded-full p-1 disabled:bg-orange-500 duration-200"
                )}>
                    <span className={classNames(
                        checked ? 'translate-x-5' : '',
                        "dot h-[16px] w-[16px] rounded-full bg-white duration-200"
                    )}>
                    </span>
                </span>
            </label>

            {
                description && (
                    <span aria-disabled={disabled} className='block text-slate-500 dark:text-slate-400 disabled:text-slate-400 mt-1 text-sm'>
                        {description}
                    </span>
                )
            }
        </>
    )
}